import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-aggregation-item',
  templateUrl: './aggregation-item.component.html',
  styleUrls: ['./aggregation-item.component.scss']
})
export class AggregationItemComponent implements OnInit {
  @Input() item: any;
  @Input() filter: any;
  @Input() type: string;
  @Input() labels: Array<string> = [];
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  itemChanged(e) {
    this.item.checked = e.target.checked;
    this.onSelect.emit({ 'key': this.item.Key, 'value': e.target.checked });
  }
}
